module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 146
// module chunks = 0